import Vue from "vue";
import i18n from "@/plugins/i18n.js";
const inputsRules = {
  install(Vue) {
    Vue.prototype.$rules = {
      required: (v) => !!v || i18n.t("inputs.required"),
      phoneNumber: (valid) =>
        valid == true || i18n.t("inputs.invalid_phone_number"),
      minPassword: (v) => (v && v.length >= 8) || i18n.t("inputs.min_password"),
      creditCard: (v) =>
        (v && v.length == 19) || i18n.t("inputs.invalid_credit_card"),
      email: (v) =>
        !v ||
        //eslint-disable-next-line
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        i18n.t("inputs.invalid_email"),
      cvv: (v) => (v && v.length === 3) || i18n.t("inputs.invalid_cvv"),
      minMax: (min, v) =>
        parseInt(v) >= parseInt(min) || i18n.t("inputs.invalid_max"),
      percent: (v) =>
        (parseInt(v) >= 0 && parseInt(v) <= 100) ||
        i18n.t("inputs.invalid_percent"),
      maxAmount: (v, max) =>
        parseFloat(v) <= parseFloat(max) || i18n.t("inputs.invalid_max_amount"),
      repeatPasswordRules: (v, pass) =>
        v === pass || i18n.t("inputs.invalid_repeat_password"),

      requiredMin0: (v) => parseInt(v) >= 0 || i18n.t("inputs.required"),
      activationCode: (v) => (v && v.length === 4) || i18n.t("inputs.required"),
      percentNotRequired: (v) =>
        (v != "" && v != null ? parseInt(v) > 0 && parseInt(v) <= 100 : true) ||
        i18n.t("inputs.invalid_percent"),
    };
  },
};
Vue.use(inputsRules);
